<template>
  <div class='index'>
    <van-tabs v-model="active" @click="rel(active)">
      <van-tab title="驾驶舱" name="0">
        <Index1 :key="arr[0].key" ref="index1" />
      </van-tab>
      <van-tab title="营收统计" name="1">
        <Index2 :key="arr[1].key" />
      </van-tab>
      <van-tab title="数据图表" name="2">
        <Index3 :key="arr[2].key" />
      </van-tab>
    </van-tabs>
    <!-- <img src="../../assets/index/a.png" style="width: 100%;" :show-menu-by-longpress="true">  长按识别二维码-->
    <div class="index_mb fl1" v-if="false">
      <div class="indexBg">
        <img src="../../assets/index/kxm.png" class="kxm-img">
        <div class="update-title">重大更新</div>
        <div class="update-card">
          <p class="update-subtitle">EV用户端全新2.0视觉提升、交互优化</p>
          <!-- <div class="divider-container">
            <div class="divider"></div>
            <div class="update-content-title">新增亮点</div>
            <div class="divider divider-reverse"></div>
          </div> -->
          <div class="update-desc">
            <span>新增亮点：</span>
            站点基本标签、服务标签、营销标签、设备使用情况、用户数据统计、VIN/电卡余额查询、订单列表/详情页字段优化;<br>
            <span>其他功能：</span>用户开票、先充后付.
          </div>
          <!-- <ul class="feature-list fl1">
            <li class="feature-item fl1">
              <img src="../../assets/index/icon1.png" class="feature-icon">
              <div class="feature-text">站点上线</div>
              <div class="feature-text">高德地图</div>
            </li>
            <li class="feature-item fl1">
              <img src="../../assets/index/icon2.png" class="feature-icon">
              <div class="feature-text">上线</div>
              <div class="feature-text">用户开票</div>
            </li>
            <li class="feature-item fl1">
              <img src="../../assets/index/icon3.png" class="feature-icon">
              <div class="feature-text">上线</div>
              <div class="feature-text">先充后付</div>
            </li>
          </ul> -->
          <div class="notice">
            <span class="notice-highlight">*</span>如您需要可把新能源设备迁移此平台，请联系您的客户经理哦~
          </div>
          <div style="text-align: center;">
            <button class="action-button" @click="open()">立即查看</button>
          </div>
        </div>
      </div>
    </div>
    <div class="index_mb fl1" v-if="dialog == 1" @click.self="dialog = 0">
      <div class="indexBox">
        <img src="../../assets/index/tcs1.png?1" style="width: 100%;">
        <img src="../../assets/icon.png" @click="dialog = 0" style="width: 4.5rem;">
      </div>
    </div>
    <div class="toastBoxModel" v-if="ev == 1" @click.self="ev = 0">
      <van-popup v-model="toastShow" mode="center" @close="toastShow = false">
        <div style="position: relative;">
          <img src="https://statics.xingkeele.com/statics/images/UI_NEWAXC_KXM4.png?t=5" mode="widthFix"
            style="width: 8.4rem;position: absolute;top: -4rem;right: -.9rem;z-index: 9;">
          </img>
          <div class="toastPop">
            <img src="https://statics.xingkeele.com/statics/images/UI_TOAST_INDEX1.png?t=5" mode="widthFix" style="width: 100%">
            </img>
            <div class="bottomButton">
              <div class="clbutton" @click="toastShow = false;ev=0">暂不处理</div>
              <div class="clbutton change" @click="toastShow = false;pla()">去处理</div>
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 确认放弃充电 feelShow3-->
    </div>
  </div>
</template>

<script>
  import Index1 from "./index11.vue"
  import Index2 from "./index2.vue"
  import Index3 from "./index3.vue"
  import { getInlet } from "@/api"
  import wx from 'weixin-js-sdk'
  import { getSysdy, getEvMore } from "@/api/sys"
  import { getTc } from "@/api/index"
  import bus from "../../store/bus"
  export default {
    components: { Index1, Index2, Index3 },
    data() {
      return {
        active: '0',
        toastShow: true,
        a: '',
        worktable: '',
        dialog: 0,
        ev: 0,
        tab: false,
        arr: [{ key: '0' }, { key: '1' }, { key: '2' }]
      };
    },
    methods: {
      pla() {
        this.ev = 0;
        this.$router.push({
          path: '/use',
        })
      },
      rel(name) {
        this.arr[name].key = new Date().getTime();
      },
      open() {
        window.open('https://mp.weixin.qq.com/s/uvtdhxTpAgpndIzr4oIjsA', '_blank');
      },
      kf() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              wx.miniProgram.navigateTo({
                url: '/pages/paykf/index?vender_id=' + localStorage.getItem("main"),
              });
              return;
            }
          })
        }
      },
      async inlet() {
        let data = await getInlet();
        this.worktable = data.data.data.check_worktable;
        let data1 = await getTc();
        this.dialog = data1.data.data.dialog;
        let data2 = await getEvMore();
        this.ev = data2.data.data.notice;
        bus.$emit("worktable", this.worktable);
      },
      async inDy() {
        let data = await getSysdy();
        this.a = data.data.data.subscribe_notice;
      },
      goIndex() {
        this.$refs.index1.golist();
      },
      gol() {
        this.dis = false;
        this.$router.push({ path: "/info" });
        window.scrollTo(0, 0);
      },
      // 弹窗一天一显示
      // showMo() {
      //     const modalKey = 'modalShownToday';
      //     const today = new Date();
      //     today.setHours(0, 0, 0, 0);
      //     const lastShown = new Date(localStorage.getItem(modalKey) || '');
      //     if (!lastShown || lastShown.getTime() !== today.getTime()) {
      //       this.dis = true;
      //       localStorage.setItem(modalKey, today.toISOString());
      //     }
      // }
    },
    created() {
      this.inDy();
    },
    mounted() {
      this.inlet();
      if (this.$route.query.int == 'false') {
        window.location.href = 'https://vender.xingkeele.com/#/index';
      };
    },
    beforeRouteEnter(to, from, next) {
      if (from.path == '/more' || from.path == '/morelist') {
        next(vm => {
          vm.goIndex();
        });
      } else {
        next();
      }
    }
  }
</script>

<style lang="less">
  .index_mb {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);

    .indexBox {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .indexBg {
      width: 80%;
      font-family: '微软雅黑';
      position: relative;
      padding: 1.3rem 1rem 1rem;
      background: url('../../assets/index/evBg.png') 0 0 no-repeat;
      background-size: 100% 100%;

      .kxm-img {
        width: 16.5rem;
        position: absolute;
        right: 0;
        top: -10.5%;
      }

      .update-title {
        font-size: 2rem;
        font-weight: 600;
        padding: 0 0 1.4rem 1.8rem;
        color: #fff;
      }

      .update-card {
        background-color: #fff;
        padding: 1.5rem 1.3rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        position: relative;
        border-radius: 1rem;
        z-index: 10;
      }

      .update-subtitle {
        font-size: 1.5rem;
        font-weight: 500;
        text-align: center;
      }

      .update-desc {
        font-size: 1.4rem;
        color: rgba(85, 92, 105, 1);
        padding: 1rem 1.4rem;
        background: rgba(255, 251, 243, 1);
        border-radius: .6rem;
        text-align: justify;
        line-height: 1.6;
      }

      .update-desc span {
        color: #000;
      }

      .divider-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
      }

      .divider {
        width: 8rem;
        height: 1px;
        background: linear-gradient(90deg, #FFFFFF 0%, #A6A6A6 100%);
      }

      .divider-reverse {
        transform: rotate(180deg);
      }

      .update-content-title {
        font-size: 1.6rem;
        font-weight: 500;
      }

      .feature-list {
        display: flex;
        justify-content: space-around;
        gap: 4rem;
      }

      .feature-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.3rem;
      }

      .feature-icon {
        width: 5rem;
        margin-bottom: 0.6rem;
      }

      .feature-text {
        font-size: 1.4rem;
      }

      .notice {
        font-size: 1.4rem;
        color: #999;
        text-align: center;
      }

      .notice-highlight {
        color: #F25757;
      }

      .action-button {
        width: 84%;
        background: linear-gradient(90deg, #1260FC 0.35%, #40B3FF 100%);
        border-radius: 9rem;
        font-size: 1.6rem;
        font-weight: 500;
        color: #fff;
        height: 4.8rem;
        border: none;
        cursor: pointer;
        margin: 1rem 0;
      }
    }
  }

  .index1 {
    height: 100vh;
    background-color: #f2f3f5;

    .h1 {
      height: 1rem;
    }

    .p1 {
      padding: 0 1rem;
    }

    .fsc {
      font-size: 1.2rem;
      color: #e9e9e9;
    }

    .tt_top {
      width: 2.4rem;
      height: 4rem;

      img {
        width: 1.7rem;
        margin-top: 1rem;
      }
    }

    .fsc1 {
      font-size: 1.3rem;
      color: #e9e9e9;
    }

    .mt_5 {
      margin-top: 0.5rem;
    }

    .fl {
      display: flex;
      align-items: flex-end;
    }

    .seamless {
      height: 3rem;
      line-height: 3rem;
    }

    .blue {
      background: url(../../assets/index/bg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      margin-top: .4rem;
      padding: 1.5rem 1.5rem 1rem !important;
    }

    .index_head_top {
      background: url(../../assets/index/bgs.png) 0 0 no-repeat;
      background-size: 100% 100%;
      padding: 1.5rem 1.5rem 1rem;

      .head_top_t {
        height: 1.8rem;

        .top_t_l {
          color: #fff;
        }

        .top_t_r {

          color: #fff;
        }
      }

      .head_top_b {
        color: #fff;

        .top_b_l {
          margin-top: .8rem;
          font-size: 2.2rem;
        }

        .top_b_r {

          text-align: right;

          .top_b_r_text {
            width: 7rem;
          }
        }
      }
    }

    .head_bom {
      width: 45%;
      line-height: 1.7;

      .head_bom_t {
        .bom_t_l {
          color: #fff;
        }

        .bom_t_r {
          img {
            width: 2.4rem;
          }
        }
      }

      .head_bom_b {

        color: #fff;
        align-items: first baseline !important;
      }
    }

    .index_tt {
      background-color: #fff;
      border-radius: .4rem;
      margin: .6rem 0;
      height: 4rem;
      color: #a5a7b1;

      .tt_box {
        display: flex;
        align-items: center;
        margin: 0 1rem;
      }

      .tt_text {
        margin-left: .4rem;
        overflow: hidden;
        width: 78%;
      }
    }

    .index_sj {
      background: #fff;
      box-shadow: 0rem .1rem .4rem .1rem rgba(0, 0, 0, 0.05);
      border-radius: .6rem;
      padding: 1.6rem;
      margin: .8rem 0;

      .index_sj_box {
        width: 50%;
        display: flex;

        .box_img {
          width: 3rem;
          height: 3rem;
        }

        .sj_box_img {
          margin: 0 1rem;
        }

        .text1 {
          margin-bottom: .4rem;
          color: #a5a7b1;
        }

        .sj_box_text {
          margin-top: .4rem;
        }

        .text2 {
          font-size: 1.5rem;
          font-weight: 600;
          color: #444;
        }
      }
    }

    .index_tu {
      height: 16rem;
      background: #fff;
      box-shadow: 0rem .1rem .2rem 0rem rgba(0, 0, 0, 0.06),
        0rem .1rem .2rem 0rem rgba(0, 0, 0, 0.06);
      border-radius: .6rem;

    }

    .ib {
      display: inline-block;
    }

    .jcsb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .fs20 {
      font-size: 2rem;
    }

    .mr6 {
      margin-right: .6rem;
    }

    .fs18 {
      font-size: 1.8rem;
    }

    .fs15 {
      font-size: 1.6rem;
    }

    .mg {
      margin: 1.3rem 0;
    }

    canvas {
      width: 98% !important;
    }
  }

  .toastPop {
    width: 31rem;
    opacity: 1;
    border-radius: 2.4rem;
    position: relative;

    .bottomButton {
      width: 100%;
      height: 9.8rem;
      padding: 0 1.3rem;
      padding-top: 2.9rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 1rem;
      z-index: 9;
      box-sizing: border-box;

      .clbutton {
        width: 12.8rem;
        height: 4.8rem;
        opacity: 1;
        border-radius: 3.6rem;
        background: rgba(255, 255, 255, 1);
        display: flex;
        color: rgba(85, 92, 105, 1);
        font-size: 1.6rem;
        justify-content: center;
        align-items: center;

        &.change {
          background: linear-gradient(90deg, rgba(18, 96, 252, 1) 0%, rgba(38, 176, 255, 1) 100%);
          color: #fff;
          font-weight: 500;
        }
      }
    }
  }

  .toastBoxModel {
    .van-popup {
      border-radius: .6rem;
      background: none;
      overflow: initial;
    }
  }
</style>